import { render, staticRenderFns } from "./StaffProfile.vue?vue&type=template&id=d651a8d4&lang=pug&"
import script from "./StaffProfile.vue?vue&type=script&lang=ts&"
export * from "./StaffProfile.vue?vue&type=script&lang=ts&"
import style0 from "./StaffProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports